"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubmitButton = void 0;
const formik_1 = require("formik");
const lodash_1 = require("lodash");
const react_1 = __importDefault(require("react"));
const components_1 = require("@/components");
const SubmitButton = (props) => {
    const { handleSubmit, errors, values, dirty } = formik_1.useFormikContext();
    const { disableOnErrors, disabled, validationSchema, allowDirty } = props, rest = __rest(props, ["disableOnErrors", "disabled", "validationSchema", "allowDirty"]);
    let invalidValues = false;
    if (validationSchema) {
        invalidValues = !validationSchema.isValidSync(values);
    }
    const allEmptyValues = !Object.values(values).some(x => (x !== null && x !== ''));
    return (react_1.default.createElement(components_1.Button, Object.assign({}, rest, { disabled: (disableOnErrors && !lodash_1.isEmpty(errors)) || disabled || allEmptyValues || invalidValues || (!allowDirty && !dirty), type: "submit", onClick: handleSubmit })));
};
exports.SubmitButton = SubmitButton;
